module.exports = __webpack_public_path__ + "static/img/MT4.54adbd9d.png";